<template>
    <div>
        <h2>Fakturační údaje</h2>
        <ssv-order-billing-information-form v-bind="$props" ref="billingInformationForm"/>
        <div class="input-item" v-if="!hideMailingAddress">
            <label class="checkbox" for="anotherMailingAddress">
                <input type="checkbox" class="checkbox__native" id="anotherMailingAddress"
                       v-model="anotherMailingAddress"> {{labels.anotherMailingAddress}}
                <span class="checkbox__control"></span>
            </label>
        </div>
        <ssv-order-mailing-address-container v-if="anotherMailingAddress" ref="mailingInformationContainer"/>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';
import SsvOrderBillingInformationForm from './BillingInformationForm';
import SsvOrderMailingAddressContainer from '../mailing-address/MailingAddressContainer';

export default {
    name:       'SsvOrderBillingInformationContainer',
    components: {
        SsvOrderMailingAddressContainer,
        SsvOrderBillingInformationForm
    },
    props:      {
        required:           {
            type:    Boolean,
            default: false,
        },
        hideMailingAddress: {
            type:    Boolean,
            default: false,
        },
        displayFullForm:    {
            type:    Boolean,
            default: false,
        },
        disableAres:        {
            type:    Boolean,
            default: false,
        },
        labels:             {
            type:     Object,
            retuired: true,
            default:  () => ({
                anotherMailingAddress: 'mám jinou korespondenční adresu',
            })
        },
        icOptional:           {
            type:    Boolean,
            default: false,
        },
    },
    watch:      {
        anotherMailingAddress: function (oldValue, newValue) {
            if (false === newValue) this.clearMailingInformations();
        },
    },
    computed:   {
        ...mapFields('ssvOrder', [
            'mailingInformation.anotherMailingAddress',
        ]),
    },
    methods:    {
        ...mapActions('ssvOrder', ['clearMailingInformations']),
        validate() {
            this.$refs.billingInformationForm.validate();
            if (!this.hideMailingAddress && this.anotherMailingAddress) {
                this.$refs.mailingInformationContainer.validate();
            }
        },
        clear() {
            this.clearMailingInformations();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/billing-information/BillingInformationContainer.vue